import React, { Component } from "react";
// import { queryserviceobject } from "../../services/crudservice";
import { app } from "../..";
import { Grid, Table, Button, Icon, Segment } from "semantic-ui-react";
import "../customerinfo/custinfo.css";
import { genexceldownload } from "../../services/fileanddownloads";
import Roundy from '../../services/roundy'
import moment from "moment";
class Payroll extends Component {
  constructor() {
    super();
    this.state = {
      startdate: null,
      enddate: null,
      reportdata: null
    };
  }
  componentDidMount() {
    this.getData();
  }
  gentable(data) {
    if (data && data.length) {
      return data.map(empdata => {
        return (
          <Table.Row error={empdata.ptobalance < 0}>
            <Table.Cell>{empdata.empnumber}</Table.Cell>
            <Table.Cell>{empdata.empname}</Table.Cell>
            <Table.Cell>{Roundy(empdata.totalhours, false)}</Table.Cell>
            <Table.Cell>{Roundy(empdata.regularhours, false)}</Table.Cell>
            <Table.Cell>{Roundy(empdata.ptoused, false)}</Table.Cell>
            <Table.Cell>{Roundy(empdata.ptocarryover, false)}</Table.Cell>
            <Table.Cell>{Roundy(empdata.ptoaccrued, false)}</Table.Cell>
            <Table.Cell>{Roundy(empdata.ptobalance, false)}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  gentableheader(data) {
    if (data) {
      return (
        <Grid>
          <Grid.Column width={7}>
            <Segment>
              <Table selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan={8}>
                      <Button
                        icon
                        id="deletecontactbutton"
                        inverted
                        color="green"
                        onClick={() => {
                          let reportdata = this.state.reportdata.map(data => {
                            delete data.status;
                            return data;
                          });
                          genexceldownload(
                            "pto_report:-" + moment().format("MM/DD/YYYY"),
                            reportdata,

                            [
                              "Employee Number",
                              "Employee Name",
                              "Total Hours",
                              "Regular Hours",
                              "PTO Used",
                              "PTO Carryover",
                              "PTO Accrued",
                              "PTO Balance"
                            ]
                          );
                        }}
                      >
                        <Icon name="download" />
                      </Button>
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell>Employee Number</Table.HeaderCell>
                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                    <Table.HeaderCell>Total Hours</Table.HeaderCell>
                    <Table.HeaderCell>Regular Hours</Table.HeaderCell>
                    <Table.HeaderCell>PTO Used</Table.HeaderCell>
                    <Table.HeaderCell>PTO Carryover</Table.HeaderCell>
                    <Table.HeaderCell>PTO Accrued</Table.HeaderCell>
                    <Table.HeaderCell>PTO Balance</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{this.gentable(data)}</Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
        </Grid>
      );
    }
  }
  getData() {
    console.log("getting data");
    app
      .service("reports")
      .find({
        query: {
          report: "pto"
        }
      })
      .then(data => {
        console.log(data);
        if (data !== this.state.reportdata) {
          this.setState({ reportdata: data });
        }
      });
  }
  render() {
    var data;

    return (
      <div className="Payroll">
        {this.gentableheader(this.state.reportdata)}
      </div>
    );
  }
}

export default Payroll;



// WEBPACK FOOTER //
// ./src/components/reports/pto.js